/**
 * The 'ACTIVATED' state.
 * @type {'ACTIVATED'}
 * @constant
 */
const ACTIVATED = 'ACTIVATED';

/**
 * The 'DEACTIVATED' state.
 * @type {'DEACTIVATED'}
 * @constant
 */
const DEACTIVATED = 'DEACTIVATED';

/**
 * The 'ENTERED' state.
 * @type {'ENTERED'}
 * @constant
 */
const ENTERED = 'ENTERED';

/**
 * The 'LEFT' state.
 * @type {'LEFT'}
 * @constant
 */
const LEFT = 'LEFT';

/**
 * The 'STARTED' state.
 * @type {'STARTED'}
 * @constant
 */
const STARTED = 'STARTED';

export {

    ACTIVATED,
    DEACTIVATED,
    ENTERED,
    LEFT,
    STARTED
};
